import { MobileTabs } from './MobileTabs'
export default MobileTabs
